import React, { FC } from 'react';
import { TextField, Tooltip } from '@mui/material';
import { formatNumberWithSpaces } from '../utils/formatNumberWithSpaces';

type ReadOnlyNumberFieldProps = {
  label: string;
  value: number | null | undefined;
  tooltip?: string;
};

export const ReadOnlyNumberField: FC<ReadOnlyNumberFieldProps> = ({
  label,
  value,
  tooltip = 'Поле рассчитывается автоматически и не редактируется вручную',
}) => (
  <Tooltip title={tooltip}>
    <TextField
      label={label}
      variant="standard"
      value={formatNumberWithSpaces(value)}
      InputProps={{ readOnly: true }}
      disabled
    />
  </Tooltip>
);
